import React from 'react';
import { FileUpload } from 'primereact/fileupload';

import { bdi_mode } from './AtributosBDI';

const FileUploadBDI = props => {
    return React.createElement(
        React.Fragment,
        null,
        props.multiple ? React.createElement(FileUpload, { name: props.name, mode: props.bdimode, multiple: true, url: props.url, accept: props.accept, onUpload: props.onUpload, maxFileSize: 1000000 }) : React.createElement(FileUpload, { name: props.name, mode: props.bdimode, url: props.url, accept: props.accept, onUpload: props.onUpload, maxFileSize: 1000000 })
    );
};

FileUploadBDI.bdi_mode = bdi_mode;

export default FileUploadBDI;